"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AdvancedModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _ConfirmModal = _interopRequireDefault(require("chaire-lib-frontend/lib/components/modal/ConfirmModal"));
// Compatibility adapter for legacy callers. New code should use ConfirmModal directly.
const AdvancedModal = props => /*#__PURE__*/_react.default.createElement(_ConfirmModal.default, {
  isOpen: props.isOpen !== false,
  closeModal: props.closeModal,
  title: props.title || "",
  cancelAction: props.cancelAction,
  confirmAction: props.confirmAction,
  showCancelButton: props.showCancelButton,
  showConfirmButton: props.showConfirmButton,
  cancelButtonLabel: props.cancelButtonLabel,
  confirmButtonLabel: props.confirmButtonLabel,
  cancelButtonColor: props.cancelButtonColor,
  confirmButtonColor: props.confirmButtonColor
}, props.container);
exports.AdvancedModal = AdvancedModal;
var _default = exports.default = AdvancedModal;